import React from 'react'
import { Span } from './SymbolRuble.styled'

const SymbolRuble = (props) => {
    return <Span>₽</Span>
}

export default SymbolRuble
